<template>
  <div  class="justify-content-center m-4 p-4 ">
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-row>
      <b-col>
        <b-form-input size="sm"
                      placeholder="Ingresa el código"
                      v-model="codigoCupon">
        </b-form-input>
        <span style="color: #46C726; font-size: 10px" v-if="cantidadDescuento !== 0 && tipoDescuento === 1">-{{ cantidadDescuento }}% de descuento</span>
        <span style="color: #46C726; font-size: 10px" v-else-if="cantidadDescuento !== 0 && tipoDescuento === 2">-{{ cantidadDescuento | moneda }} de descuento</span>
        <span style="color: rgb(255, 0, 0); font-size: 10px" v-else >{{ mensajeErrorCupon }}</span>
      </b-col>
      <b-col>
        <b-button variant="outline-info" @click="obtenerHerramientaCierreSimulacion" size="md" pill style="font-size:.7em !important; font-weight: 500">
           Aplicar
        </b-button>
      </b-col>
      <b-col>
        <span style="font-size: 10px" v-b-tooltip.hover.v-light.topright="'' "> Total de inversión:</span>
        <span style="font-size: 12px; font-weight: 500; color: #0069A9 "> {{ totalInversion | monedaEntero }} </span>
        <hr/>
        <span v-if="totalCopago != null && totalCopago >0" style="color: red; font-size: 8px">Solo aplica para tratamientos sin copago</span>
        <p v-if="totalCopago != null && totalCopago >0" style="color: red; font-size: 8px">Copago: {{totalCopago | moneda}}</p>
      </b-col>

    </b-row>

    <div>
      <b-row>
        <b-col class="text-center textSize">
          <br/>
          <br/>
          <br/>
          <span v-if="!noAplica" style="font-size: 12px; color: #929292">Ingresa la herramienta de cierre para continuar</span>
          <div v-else>
             <span style="font-size: 12px; color: #0069A9 "> Inversión final: </span>
              <span style="font-size: 12px; color: #0069A9 ">{{(totalInversion - descuentoTotalCupon) | monedaEntero  }}</span>
              <br/>

              <span style="font-size: 12px; font-weight: 500; color: #46C726 "> Descuento: </span>
              <span style="font-size: 12px; font-weight: 500; color: #46C726 " v-if="descuentoTotalCupon === 0">
                {{ 0 | monedaEntero }}
              </span>
              <span style="font-size: 12px; font-weight: 500; color: #46C726 " v-else>
                {{descuentoTotalCupon | monedaEntero}}
              </span>
          </div>
        </b-col>
      </b-row>
    </div>


  </div>
</template>
<script>
export default {
  name: "HerramientaCierrePF",
  props: {
    totalInversion: Number,
    tratamientosInversion: Array,
    idPaciente: Number,
    totalCopago: Number
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    codigoCupon: null,
    datosCupon: null,
    mensajeErrorCupon: "",
    descuentoTotalCupon: 0,
    tipoDescuento: 0,
    noAplica: false,
    cantidadDescuento: 0

  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    obtenerHerramientaCierreSimulacion() {
      const params = {
        montoPagar: this.totalInversion,
        idPaciente: this.idPaciente,
        codigo: this.codigoCupon
      }

      this.$http.post(this.$api + "cupon/obtenerHerramientaCierreSimulacion", params).then(respuesta => {
        if (respuesta.data.data) {
          this.noAplica = true
          this.datosCupon = respuesta.data.data;

          if (this.datosCupon.msjExito) {
            this.mensajeErrorCupon = "";
            this.cantidadDescuento = this.datosCupon.cantidadDescuento;
            this.tipoDescuento = this.datosCupon.tipoDescuento;

            // Tipo de aplicacion a CUENTA
            if (this.datosCupon.tipoAplicacionDescuento === 1) {
              if (this.datosCupon.tipoDescuento === 1) { // Porcentaje
                let montoDescuento = 0;
                this.tratamientosInversion.forEach(txInversion => {
                  if(txInversion.agregadoACarrito){
                    txInversion.tratamientos.forEach(tx => {
                      let descuentoPlan = 0;
                      if(tx.lstCalcDesc != null){
                        tx.lstCalcDesc.forEach(calcDesc => {
                          descuentoPlan += calcDesc.montoCopagoFijo != null
                              ? calcDesc.precioTratamientoOriginal
                              : calcDesc.montoDescuentoVale != null
                                  ? calcDesc.montoDescuentoVale
                                  : calcDesc.montoDescuentoPlan
                        });
                      }
                      if (tx.total > 0 && tx.descuentoPromo === 0) {
                        montoDescuento += Math.ceil((tx.subtotal - descuentoPlan) * this.datosCupon.cantidadDescuento / 100);
                      }
                    })
                  }
                })
                this.descuentoTotalCupon = montoDescuento;
              }

              else { // Efectivo
                let montoDescuento = 0;
                let montoDescuentoCupon = this.datosCupon.cantidadDescuento;
                this.tratamientosInversion.forEach(txInversion => {
                  if(txInversion.agregadoACarrito){
                    txInversion.tratamientos.forEach((tx) => {
                      let descuentoPlan = 0;
                      if(tx.lstCalcDesc != null){
                        tx.lstCalcDesc.forEach(calcDesc => {
                          descuentoPlan += calcDesc.montoCopagoFijo != null
                              ? calcDesc.precioTratamientoOriginal
                              : calcDesc.montoDescuentoVale != null
                                  ? calcDesc.montoDescuentoVale
                                  : calcDesc.montoDescuentoPlan
                        });
                      }
                      if(tx.total > 0 && tx.descuentoPromo === 0 && montoDescuentoCupon > 0){
                        if (montoDescuentoCupon < (tx.subtotal - descuentoPlan)) {
                          montoDescuento += montoDescuentoCupon;
                          montoDescuentoCupon = 0;
                        } else {
                          montoDescuento += tx.subtotal - descuentoPlan;
                          montoDescuentoCupon -= tx.subtotal - descuentoPlan;
                        }
                      }
                    })
                  }
                })
                this.descuentoTotalCupon = montoDescuento;
              }
            }

            //Tipo de aplicacion a TX
            else {
              if (this.datosCupon.tipoDescuento === 1) { // Porcentaje
                let montoDescuento = 0;
                this.tratamientosInversion.forEach(txInversion => {
                  if(txInversion.agregadoACarrito){
                    if (this.datosCupon.idsTratamientos.some(ids => ids === txInversion.idTratamiento)) {
                      txInversion.tratamientos.forEach(tx => {
                        let descuentoPlan = 0;
                        if(tx.lstCalcDesc != null){
                          tx.lstCalcDesc.forEach(calcDesc => {
                            descuentoPlan += calcDesc.montoCopagoFijo != null
                                ? calcDesc.precioTratamientoOriginal
                                : calcDesc.montoDescuentoVale != null
                                    ? calcDesc.montoDescuentoVale
                                    : calcDesc.montoDescuentoPlan
                          });
                        }
                        if (tx.total > 0 && tx.descuentoPromo === 0) {
                          montoDescuento += Math.ceil((tx.subtotal - descuentoPlan) * this.datosCupon.cantidadDescuento / 100);
                        }
                      })
                    }
                  }
                })
                this.descuentoTotalCupon = montoDescuento;
              }

              // Efectivo
              else {
                let montoDescuento = 0;
                let montoDescuentoCupon = this.datosCupon.cantidadDescuento;
                this.tratamientosInversion.forEach(txInversion => {
                  if(txInversion.agregadoACarrito) {
                    if (this.datosCupon.idsTratamientos.some(ids => ids === txInversion.idTratamiento)) {
                      txInversion.tratamientos.forEach((tx) => {
                        let descuentoPlan = 0;
                        if(tx.lstCalcDesc != null){
                          tx.lstCalcDesc.forEach(calcDesc => {
                            descuentoPlan += calcDesc.montoCopagoFijo != null
                                ? calcDesc.precioTratamientoOriginal
                                : calcDesc.montoDescuentoVale != null
                                    ? calcDesc.montoDescuentoVale
                                    : calcDesc.montoDescuentoPlan
                          });
                        }
                        if (tx.total > 0 && tx.descuentoPromo === 0) {
                          if (montoDescuentoCupon < (tx.subtotal - descuentoPlan)) {
                            montoDescuento += montoDescuentoCupon;
                            montoDescuentoCupon = 0;
                          } else {
                            montoDescuento += tx.subtotal - descuentoPlan;
                            montoDescuentoCupon -= tx.subtotal - descuentoPlan;
                          }
                        }
                      })
                    }
                  }
                })
                this.descuentoTotalCupon = montoDescuento;
              }
            }
          } else {
            this.mensajeErrorCupon = this.datosCupon.mensajeDeError;
          }
        }
      }).catch(error => {
        console.error(error)
      })
    }
  }
}
</script>
<style scoped>

</style>